/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-28 10:44:39
 * @LastEditors: jyf
 * @LastEditTime: 2022-11-21 10:20:54
 */

export function tableRowClassName({ row, rowIndex }) {
    if (rowIndex % 2 == 0) {
        return '';
    }
    return 'success-row';
}


export const pickerOptions = {
    shortcuts: [{
        text: '今天',
        onClick(picker) {
            picker.$emit('pick', new Date());
        }
    }, {
        text: '昨天',
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
        }
    }, {
        text: '一周前',
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
        }
    }]
}
export const  pickerOptions1  = {
    shortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
}
export function getExtension(name) {
    let imglist = ['.png', '.jpg', '.jpeg', '.bmp', '.gif'];
    return imglist.includes(name.substring(name.lastIndexOf(".")))
}
export function getExtension2(name) {
    let filelist = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
    return filelist.includes(name.substring(name.lastIndexOf(".")))
}

export function isFile(name) {
    let filelist = [".doc", ".docx", ".xls", ".xlsx", ".png", '.jpg', '.jpeg', ".doc", ".gif", ".pdf",".rar"]
    return filelist.includes(name.substring(name.lastIndexOf(".")))
}

export function copyInquiryData(res) {
    let fileList = [];
    let goodsList: any = [];
    goodsList = [
        {
            goodsName: res.goodsName,
            quantityOfGoods: res.quantityOfGoods,
            goodsUnit: res.goodsUnit,
            goodsUnitStr: res.goodsUnitStr,
        },
        ...res.goodsList,
    ];
    let addForm = {
        customerId: res.customerId,
        customerName: res.customerName,
        customerPhone: res.customerPhone,
        content: res.content,
        biddingDeadLine: res.biddingDeadLine,
        status: res.status,
        isInvoice: res.isInvoice,
        items: [],
        attachmentList: res.attachmentList,
    };
    addForm.isInvoice = res.isInvoice;
    fileList = res.attachmentList.map((list) => {
        return {
            name: list.name,
            url: list.path,
        };
    });
    addForm.items[0] = {
        destination: {
            province: res.destinationProvince,
            city: res.destinationCity,
            county: res.destinationCounty,
            details: res.destinationDetails,
            provinceName: res.destinationProvinceStr,
            cityName: res.destinationCityStr,
            countyName: res.destinationCountyStr,
        },
        origin: {
            province: res.originProvince,
            city: res.originCity,
            county: res.originCounty,
            details: res.originDetails,
            provinceName: res.originProvinceStr,
            cityName: res.originCityStr,
            countyName: res.originCountyStr,
        },
        foreArrivalTime: res.foreArrivalTime,
        goodsName: res.goodsName,
        quantityOfGoods: res.quantityOfGoods,
        goodsUnit: res.goodsUnit,
        vehicleType: res.vehicleType,
        carLength: res.carLength,
        carriageWay: res.carriageWay,
        vehicleCount: res.vehicleCount,
        loadingEffect: res.loadingEffect,
        mileage: res.mileage,
        goodsList: res.goodsList,
    };
    addForm.customerName = !res.customerIsEnabled?'':res.customerName;
    addForm.customerPhone = !res.customerIsEnabled?'':res.customerPhone; 
    addForm.customerId =  !res.customerIsEnabled?'':res.customerId;
    return {
        addForm: addForm,
        fileList: fileList,
        goodsList: goodsList
    }
}

// 自适应表格列宽
export function  flexColumnWidth(str, tableData, flag = 'max') {
    // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
    // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
    // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
    str = str + '';
    let columnContent = '';
    if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
        return '140px';
    }
    if (!str || !str.length || str.length === 0 || str === undefined) {
        return;
    }
    if (flag === 'equal') {
        // 获取该列中第一个不为空的数据(内容)
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i][str].length > 0) {
                // console.log('该列数据[0]:', tableData[0][str])
                columnContent = tableData[i][str];
                break;
            }
        }
    } else {
        // 获取该列中最长的数据(内容)
        let index = 0;
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i][str] === null) {
                return;
            }
            const now_temp = tableData[i][str] + '';
            const max_temp = tableData[index][str] + '';
            if (now_temp.length > max_temp.length) {
                index = i;
            }
        }
        columnContent = tableData[index][str];
    }
    // console.log('该列数据[i]:', columnContent)
    // 以下分配的单位长度可根据实际需求进行调整
    let flexWidth = 0;
    for (const char of columnContent) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
            // 如果是英文字符，为字符分配8个单位宽度
            flexWidth += 9;
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
            // 如果是中文字符，为字符分配15个单位宽度
            flexWidth += 16;
        } else {
            // 其他种类字符，为字符分配8个单位宽度
            flexWidth += 9;
        }
    }
    if (flexWidth < 160) {
        // 设置最小宽度
        flexWidth = 160;
    }
    // if (flexWidth > 250) {
    //   // 设置最大宽度
    //   flexWidth = 250
    // }
    return flexWidth + 10 + 'px';
}

export default {
    tableRowClassName,
    pickerOptions,
    copyInquiryData,
    getExtension,
    getExtension2,
    isFile,
    pickerOptions1,
    flexColumnWidth
};